import React from "react";

interface ILandmarkIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const LandmarkIcon: React.FC<ILandmarkIconProps> = ({ sizeX = 16, sizeY = 16 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 14.6668H14M4 12.0002V7.3335M6.66667 12.0002V7.3335M9.33333 12.0002V7.3335M12 12.0002V7.3335M8 1.3335L13.3333 4.66683H2.66667L8 1.3335Z"
                stroke="#64469E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}
